<template>
  <b-modal class="modal-lg" v-if="getModalLevel('query') == 'main'" id="queryModal" ref="query-modal" :title="queryModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="fetchAdditionalInfo(queryModal.modalData.entries)" @hide="resetModal('main');clearModal();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'comments']" size="1x" class="mr-2"/> {{ queryModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close();resetModal(queryModal.modalData.level);"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="vld-parent text-center">
        <div autofocus>
          <!--<div @transitioncancel="loaderStopped">-->
            <loading
            :active.sync="modalIsBusy"
            :can-cancel="false"
            :color="'#047bf8'"
            :loader="'dots'"
            :is-full-page="false"></loading>
          <!--</div>-->
          <div v-if="!modalIsBusy" >
            <template v-if="queryModal.docuData.docsChecked && queryModal.docuData.docsChecked.length">
              <b-card no-body>
                <b-tabs id="query-tabs" pills card vertical active-nav-item-class="text-uppercase doc-button">
                  <b-tab :title="t('labelGeneral','labelGeneral')" active>
                    <h5 class="">{{ t('raiseQueryModalHeading', 'raiseQueryModalHeading') }}</h5>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="query-name" class="text-center">{{t('labelName','labelName') }}</label>
                        <input id="query-name" v-model="formData.general.name" class="form-control" :placeholder="t('labelName','labelName')" type="text">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="query-email" class="text-center">{{t('labelEmail','labelEmail') }} *</label>
                        <input id="query-email" v-model="formData.general.email" class="form-control" :placeholder="t('labelEmailaddress','labelEmailaddress')" type="text" required>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="query-telephone" class="">{{t('labelTelephone','labelTelephone') }} *</label>
                        <input id="query-telephone" v-model="formData.general.telephone" class="form-control" :placeholder="t('labelTelephone','labelTelephone')" type="text" required>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="query-preferred" class="">{{t('raiseQueryModalPreferredMethod','raiseQueryModalPreferredMethod') }}</label>
                        <!--<b-form-select id="query-preferred" v-model="formData.general.preferred" :options="methods"></b-form-select>-->
                        <b-form-select id="query-preferred" v-model="formData.general.preferred">
                          <b-form-select-option value="">{{t('choosePreferredMethod','choosePreferredMethod')}}</b-form-select-option>
                          <b-form-select-option value="telephone">{{t('labelTelephone','labelTelephone')}}</b-form-select-option>
                          <b-form-select-option value="email">{{t('labelEmail','labelEmail')}}</b-form-select-option>
                        </b-form-select>
                      </div>
                      <label for="query-nature" class="d-block">{{t('raiseQueryModalNatureOfQuery','raiseQueryModalNatureOfQuery') }}</label>
                      <b-form-textarea id="query-nature" v-model="formData.general.nature" class="form-control col-12" rows="5" max-rows="5">
                      </b-form-textarea>
                    </div>
                    <p>{{t('raiseQueryModalDesc', 'raiseQueryModalDesc')}}</p>
                    <p v-if="mandatoryNotFilled" class="text-danger">{{t('cantChangeTabsUntilFillMandatory', 'cantChangeTabsUntilFillMandatory')}}</p>
                  </b-tab>
                  <b-tab v-for="(doc, index) in queryModal.docuData.docIndexes" v-bind:key="'tab_'+index" :title="doc[1]" :disabled="mandatoryNotFilled" >
                    <h5 class="">{{ t('raiseQueryModalQueryDetails', 'raiseQueryModalQueryDetails') }}: {{doc[1]}}</h5>
                    <div class="form-row">
                      <label :for="'query-nature-' + doc[0]" class="d-block">{{t('raiseQueryModalNatureOfQuery','raiseQueryModalNatureOfQuery') }}</label>
                      <b-form-textarea :id="'query-nature-' + doc[0]" v-model="formData[doc[0]].nature" class="form-control col-12" rows="5" max-rows="5">
                      </b-form-textarea>
                    </div>
                    <p>{{t('raiseQueryModalFurtherDesc', 'raiseQueryModalFurtherDesc')}}</p>
                  </b-tab>
                </b-tabs>
              </b-card>
              <ResponseInfo v-if="getResponseInfo.responseName == 'documentsView'"></ResponseInfo>
            </template>
            <template v-else>
              <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
              <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="queryModal.docuData.docsChecked.length">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="RaiseQuery" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="!formData.general.telephone || !formData.general.email" @click="raiseQuery()">
          {{ t('sendQueryButtonText', 'sendQueryButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
  <b-modal class="modal-lg" v-else id="subQueryModal" ref="query-modal" :title="queryModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="fetchAdditionalInfo()" @hide="resetModal('sub');clearModal();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'comments']" size="1x" class="mr-2"/> {{ queryModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="vld-parent text-center">
        <div autofocus>
          <div @transitioncancel="loaderStopped">
            <loading
            :active.sync="modalIsBusy"
            :can-cancel="false"
            :color="'#047bf8'"
            :loader="'dots'"
            :is-full-page="false"></loading>
          </div>
          <div v-if="loaderBusy === false" >
            <template v-if="queryModal.docuData.docsChecked && queryModal.docuData.docsChecked.length">
              <b-card no-body>
                <b-tabs id="query-tabs" pills card vertical active-nav-item-class="text-uppercase doc-button">
                  <b-tab :title="t('labelGeneral','labelGeneral')" active>
                    <h5 class="">{{ t('raiseQueryModalHeading', 'raiseQueryModalHeading') }}</h5>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="query-name" class="text-center">{{t('labelName','labelName') }}</label>
                        <input id="query-name" v-model="formData.general.name" class="form-control" :placeholder="t('labelName','labelName')" type="text">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="query-email" class="text-center">{{t('labelEmail','labelEmail') }} *</label>
                        <input id="query-email" v-model="formData.general.email" class="form-control" :placeholder="t('labelEmailaddress','labelEmailaddress')" type="text" required>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="query-telephone" class="">{{t('labelTelephone','labelTelephone') }} *</label>
                        <input id="query-telephone" v-model="formData.general.telephone" class="form-control" :placeholder="t('labelTelephone','labelTelephone')" type="text" required>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="query-preferred" class="">{{t('raiseQueryModalPreferredMethod','raiseQueryModalPreferredMethod') }}</label>
                        <!--<b-form-select id="query-preferred" v-model="formData.general.preferred" :options="methods"></b-form-select>-->
                        <b-form-select id="query-preferred" v-model="formData.general.preferred">
                          <b-form-select-option value="">{{t('choosePreferredMethod','choosePreferredMethod')}}</b-form-select-option>
                          <b-form-select-option value="telephone">{{t('labelTelephone','labelTelephone')}}</b-form-select-option>
                          <b-form-select-option value="email">{{t('labelEmail','labelEmail')}}</b-form-select-option>
                        </b-form-select>
                      </div>
                      <label for="query-nature" class="d-block">{{t('raiseQueryModalNatureOfQuery','raiseQueryModalNatureOfQuery') }}</label>
                      <b-form-textarea id="query-nature" v-model="formData.general.nature" class="form-control col-12" rows="5" max-rows="5">
                      </b-form-textarea>
                    </div>
                    <p>{{t('raiseQueryModalDesc', 'raiseQueryModalDesc')}}</p>
                    <p v-if="mandatoryNotFilled" class="text-danger">{{t('cantChangeTabsUntilFillMandatory', 'cantChangeTabsUntilFillMandatory')}}</p>
                  </b-tab>
                  <b-tab v-for="(doc, index) in queryModal.docuData.docIndexes" v-bind:key="'tab_'+index" :title="doc[1]" :disabled="mandatoryNotFilled" >
                    <h5 class="">{{ t('raiseQueryModalQueryDetails', 'raiseQueryModalQueryDetails') }}: {{doc[1]}}</h5>
                    <div class="form-row">
                      <label :for="'query-nature-' + doc[0]" class="d-block">{{t('raiseQueryModalNatureOfQuery','raiseQueryModalNatureOfQuery') }}</label>
                      <b-form-textarea :id="'query-nature-' + doc[0]" v-model="formData[doc[0]].nature" class="form-control col-12" rows="5" max-rows="5">
                      </b-form-textarea>
                    </div>
                    <p>{{t('raiseQueryModalFurtherDesc', 'raiseQueryModalFurtherDesc')}}</p>
                  </b-tab>
                </b-tabs>
              </b-card>
              <ResponseInfo v-if="getResponseInfo.responseName == 'documentsView'"></ResponseInfo>
            </template>
            <template v-else>
              <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
              <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="queryModal.docuData.docsChecked.length">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="RaiseQuery" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="!formData.general.telephone || !formData.general.email" @click="raiseQuery()">
          {{ t('sendQueryButtonText', 'sendQueryButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'

export default {
  name: 'ModalRaiseQuery',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'getModalLevel',
    'searchDocuments'
  ],
  data () {
    return {
      //queryModal: {},
      loaderBusy: true,
      modalIsBusy: true,
      buttonIsBusy: false,
      tooltipTargets: [],
      /*
      methods:  [
        { value: 'telephone', text: this.t('labelTelephone' , 'labelTelephone') },
        { value: 'email', text: this.t('labelEmail', 'labelEmail') }
      ],*/
      formData: {
        general: {}
      },
      savedEmail: false,
      savedName: false,
      savedTelephone: false,
      buttonIsBusy: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo','getUserDetails']),
    documents() {
      return this.$store.getters['documentsStore/getDocuments']
    },
    mandatoryNotFilled() {
      let email = false
      let telephone = false
      if((this.formData.general.email && this.formData.general.email.length) || this.savedEmail.length) {
        email = true
      }
      if((this.formData.general.telephone && this.formData.general.telephone.length) || this.savedTelephone.length) {
        telephone = true
      }
      if(email && telephone) {
        return false
      } else {
        return true
      }
    },
    queryModal:{
      get:function(){
        return this.$attrs.modal
      },
      set:function(d){
        this.queryModal = d
      }
    }
  },
  methods:{
    clearModal() {
      this.formData = {
        general: {}
      }
      this.tooltipTargets = []
    },
    loaderStopped() {
      this.loaderBusy = false
    },
    fetchAdditionalInfo(entries) {
      //clear previous response
      this.$store.dispatch('alertClearResponse')
      this.loaderBusy = true
      this.modalIsBusy = true
      let checkedDocs = this.queryModal.docuData.docsChecked
      let docIndexes = []
      let docInfos = []
      if((entries == 'single') || (entries == undefined)) {
        let reference = ''
        if(this.queryModal.docuData.docInfo == undefined) {
          reference = this.queryModal.docuData.statuses.reference
        } else {
          reference = this.queryModal.docuData.docInfo.reference
        }

        docIndexes.push([this.queryModal.docuData.statuses.docId, reference])
        docInfos.push({id: this.queryModal.docuData.statuses.docId, reference:  reference, customer: this.queryModal.docuData.statuses.customer})

      }
      if(entries == 'multi') {
        Object.keys(this.documents.data).forEach(
          (key) => (checkedDocs.includes(this.documents.data[key].id)) ? (
            (docIndexes.push([this.documents.data[key].id, this.documents.data[key].reference]))
            &&
            //(this.formData.docInfos.push({id: this.documents.data[key].id, reference: this.documents.data[key].reference, customer: this.documents.data[key].customer_ref }))
            (docInfos.push({id: this.documents.data[key].id, reference: this.documents.data[key].reference, customer: this.documents.data[key].customer_ref }))
          ) : ''
        )
      }

      this.queryModal.docuData.docIndexes = docIndexes
      this.formData.docInfos = docInfos

      checkedDocs.forEach( (key) => (this.formData[key] = { }))

      this.savedName = this.getUserDetails.name
      this.savedEmail = this.getUserDetails.email
      this.savedTelephone = this.getUserDetails.telephone

      if(this.savedName.length) {
        this.formData.general.name = this.savedName
      }
      if(this.savedEmail) {
        this.formData.general.email = this.savedEmail
      }
      if(this.savedTelephone) {
        this.formData.general.telephone = this.savedTelephone
      }

      this.formData.general.preferred = ''

      this.loaderBusy = false
      this.modalIsBusy = false
    },
    raiseQuery() {
      this.buttonIsBusy = true
      this.$store.dispatch('documentToolsStore/handleDocumentTool',{
        action: 'raiseQuery',
        documents: this.queryModal.docuData.docsChecked,
        queryDetails: this.formData,
        //docInfo: this.formData.docInfos
      })
      .then(() => {
        this.buttonIsBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$refs['query-modal'].hide()
          this.searchDocuments()
        }
      })
    }
  },
  created() {
    //this.queryModal = this.$attrs.modal
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo,
    Loading
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #queryModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
/*main modal level*/
.modal-open #queryModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #queryModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 520px;
  overflow-y: scroll;
}
/*sub modal level*/
.modal-open #subQueryModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #subQueryModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 520px;
  overflow-y: scroll;
}
.doc-list {
  width: 300px;
  height: 250px;
  overflow: auto;
}
.nav-link >>> .doc-button{
  border-radius: 0 !important;
}
</style>
